import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileStickyBar from '@/components/feature/MobileStickyBar';
import useSEO from '@/hooks/useSEO';

const allProjects = [
  { img: 'https://public.readdy.ai/ai/img_res/0ef2c2881873eaff94f67840e2d3ae5a.jpg', title: 'Master Bath Frameless Enclosure', location: 'Summerlin, NV', category: 'Shower Doors' },
  { img: 'https://readdy.ai/api/search-image?query=modern%20glass%20stair%20railing%20with%20clear%20tempered%20glass%20panels%20and%20stainless%20steel%20posts%20in%20contemporary%20home%20interior%2C%20open%20staircase%20design%2C%20professional%20photo&width=700&height=500&seq=gal002&orientation=landscape', title: 'Open Staircase Glass Railing', location: 'Henderson, NV', category: 'Railings' },
  { img: 'https://readdy.ai/api/search-image?query=large%20custom%20frameless%20mirror%20wall%20in%20modern%20bathroom%20with%20double%20vanity%2C%20LED%20lighting%2C%20white%20marble%20countertop%2C%20luxury%20interior%20design&width=700&height=500&seq=gal003&orientation=landscape', title: 'Custom Double Vanity Mirror', location: 'Las Vegas, NV', category: 'Mirrors' },
  { img: 'https://readdy.ai/api/search-image?query=glass%20bathtub%20enclosure%20with%20sliding%20door%20in%20luxury%20bathroom%2C%20clear%20tempered%20glass%2C%20brushed%20gold%20hardware%2C%20freestanding%20tub%2C%20modern%20design&width=600&height=800&seq=gal004&orientation=portrait', title: 'Luxury Tub Enclosure', location: 'Spring Valley, NV', category: 'Tub Enclosures' },
  { img: 'https://readdy.ai/api/search-image?query=frameless%20glass%20office%20partition%20wall%20in%20modern%20corporate%20office%2C%20frosted%20glass%20panels%2C%20contemporary%20workspace%2C%20natural%20light%2C%20professional%20interior&width=700&height=500&seq=gal005&orientation=landscape', title: 'Corporate Glass Partition', location: 'Las Vegas, NV', category: 'Partitions' },
  { img: 'https://readdy.ai/api/search-image?query=modern%20glass%20balcony%20railing%20in%20luxury%20Las%20Vegas%20home%20with%20desert%20mountain%20view%2C%20clear%20tempered%20glass%20panels%2C%20stainless%20steel%20hardware%2C%20contemporary%20architecture&width=700&height=500&seq=gal006&orientation=landscape', title: 'Balcony Glass Railing', location: 'Henderson, NV', category: 'Railings' },
  { img: 'https://readdy.ai/api/search-image?query=custom%20gym%20mirror%20wall%20installation%20in%20modern%20home%20gym%2C%20large%20frameless%20mirrors%2C%20professional%20fitness%20space%2C%20clean%20white%20walls%2C%20bright%20lighting&width=600&height=800&seq=gal007&orientation=portrait', title: 'Home Gym Mirror Wall', location: 'Summerlin, NV', category: 'Mirrors' },
  { img: 'https://readdy.ai/api/search-image?query=walk-in%20frameless%20glass%20shower%20enclosure%20with%20rain%20shower%20head%2C%20white%20marble%20tiles%2C%20modern%20luxury%20bathroom%2C%20professional%20interior%20photography&width=700&height=500&seq=gal008&orientation=landscape', title: 'Walk-In Glass Shower', location: 'Paradise, NV', category: 'Shower Doors' },
  { img: 'https://readdy.ai/api/search-image?query=elegant%20sliding%20glass%20shower%20door%20with%20brushed%20nickel%20hardware%2C%20clear%20tempered%20glass%2C%20contemporary%20bathroom%2C%20professional%20photography&width=600&height=800&seq=gal009&orientation=portrait', title: 'Sliding Shower Door', location: 'North Las Vegas, NV', category: 'Shower Doors' },
  { img: 'https://readdy.ai/api/search-image?query=glass%20stair%20railing%20with%20frameless%20panels%20in%20modern%20luxury%20home%2C%20open%20concept%20design%2C%20natural%20light%2C%20professional%20interior%20design%20photography&width=700&height=500&seq=gal010&orientation=landscape', title: 'Interior Stair Glass Panels', location: 'Las Vegas, NV', category: 'Railings' },
  { img: 'https://readdy.ai/api/search-image?query=large%20bathroom%20mirror%20with%20decorative%20frame%20in%20luxury%20master%20bathroom%2C%20double%20sink%20vanity%2C%20marble%20countertop%2C%20elegant%20interior%20design&width=700&height=500&seq=gal011&orientation=landscape', title: 'Master Bath Mirror', location: 'Henderson, NV', category: 'Mirrors' },
  { img: 'https://readdy.ai/api/search-image?query=glass%20tub%20enclosure%20with%20hinged%20door%20in%20luxury%20bathroom%2C%20clear%20glass%20panels%2C%20chrome%20hardware%2C%20freestanding%20bathtub%2C%20professional%20photography&width=600&height=800&seq=gal012&orientation=portrait', title: 'Hinged Tub Enclosure', location: 'Summerlin, NV', category: 'Tub Enclosures' },
];

const categories = ['All', 'Shower Doors', 'Railings', 'Mirrors', 'Tub Enclosures', 'Partitions'];

const GalleryPage = () => {
  useSEO({
    title: 'Glass Installation Gallery Las Vegas | Quinolux Glass & Mirrors',
    description: 'Browse our gallery of custom glass installations in Las Vegas — frameless shower doors, glass railings, custom mirrors, tub enclosures, and more. Real projects, real results.',
    keywords: 'glass installation gallery Las Vegas, frameless shower door photos, glass railing photos Las Vegas, custom mirror installation gallery',
    canonical: 'https://quinoluxglass.com/gallery',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'ImageGallery',
      name: 'Quinolux Glass & Mirrors — Project Gallery Las Vegas',
      description: 'Portfolio of custom glass installations in Las Vegas — frameless shower doors, glass railings, custom mirrors, tub enclosures, and glass partitions.',
      url: `${import.meta.env.VITE_SITE_URL ?? 'https://quinoluxglass.com'}/gallery`,
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: `${import.meta.env.VITE_SITE_URL ?? 'https://quinoluxglass.com'}/` },
          { '@type': 'ListItem', position: 2, name: 'Gallery', item: `${import.meta.env.VITE_SITE_URL ?? 'https://quinoluxglass.com'}/gallery` },
        ],
      },
      author: {
        '@type': 'LocalBusiness',
        name: 'Quinolux Glass & Mirrors',
        telephone: '+17026042093',
      },
    },
  });

  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState<null | typeof allProjects[0]>(null);

  const filtered = activeCategory === 'All' ? allProjects : allProjects.filter(p => p.category === activeCategory);

  return (
    <main>
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4 block">Our Portfolio</span>
          <h1 className="text-5xl md:text-6xl font-light text-white mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Project Gallery
          </h1>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            Real installations. Real results. Browse our portfolio of custom glass work across Las Vegas, Henderson, Summerlin, and the entire Las Vegas Valley.
          </p>
        </div>
      </section>

      {/* Filter + Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-2 mb-10 overflow-x-auto scrollbar-hide pb-1">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${activeCategory === cat ? 'bg-black text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Masonry */}
          <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 space-y-4">
            {filtered.map(item => (
              <div
                key={item.title}
                className="break-inside-avoid group cursor-pointer relative overflow-hidden rounded-2xl"
                onClick={() => setLightbox(item)}
              >
                <img src={item.img} alt={item.title} className="w-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 overflow-hidden rounded-2xl pointer-events-none">
                  <div className="absolute -inset-full top-0 h-full w-1/2 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 opacity-0 group-hover:opacity-100 group-hover:translate-x-[300%] transition-all duration-700 ease-out" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 rounded-2xl" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400">
                  <span className="text-xs font-semibold text-white/70 uppercase tracking-wider">{item.category}</span>
                  <p className="text-white font-semibold text-sm mt-0.5">{item.title}</p>
                  <p className="text-white/60 text-xs flex items-center gap-1 mt-0.5"><i className="ri-map-pin-line"></i>{item.location}</p>
                </div>
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-fullscreen-line text-white text-sm"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#F8F8F6] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-4xl font-light text-black mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Love What You See?</h2>
          <p className="text-gray-500 text-sm mb-8">Get a free estimate for your custom glass project in Las Vegas.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/free-quote" className="inline-flex items-center gap-2 bg-black text-white text-sm font-semibold px-8 py-4 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">Get Free Quote</Link>
            <a href="tel:+17026042093" className="inline-flex items-center gap-2 border border-gray-300 text-black text-sm font-medium px-8 py-4 rounded-full hover:border-black transition-colors whitespace-nowrap cursor-pointer"><i className="ri-phone-fill"></i>(702) 604-2093</a>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 z-[200] bg-black/92 flex items-center justify-center p-4 cursor-pointer" onClick={() => setLightbox(null)}>
          <div className="relative max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <button onClick={() => setLightbox(null)} className="absolute -top-12 right-0 text-white/70 hover:text-white text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
              <i className="ri-close-line text-xl"></i> Close
            </button>
            <img src={lightbox.img} alt={lightbox.title} className="w-full max-h-[80vh] object-contain rounded-2xl" />
            <div className="mt-4 text-center">
              <p className="text-white font-semibold">{lightbox.title}</p>
              <p className="text-white/50 text-sm flex items-center justify-center gap-1 mt-1"><i className="ri-map-pin-line"></i>{lightbox.location}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <MobileStickyBar />
    </main>
  );
};

export default GalleryPage;
